import { Language } from "../types/commons";

/**
 * This utils function is a workaround for getting the language code from the userDetails by Coastguard.
 * Coastguard stores language as a String (language, region): e.g. "en-EN".
 */
const DEFAULT_LANGUAGE_CODE = "EN";

export function getLanguageCode(language: string | null | undefined): Language {
	if (!language) {
		return DEFAULT_LANGUAGE_CODE;
	}

	const pattern = /^([a-zA-Z]+)/;
	const patternMatches = language.match(pattern);

	if (patternMatches && patternMatches.length > 1) {
		return patternMatches[1].toUpperCase() as Language;
	}

	return DEFAULT_LANGUAGE_CODE;
}
